
import apiMixin from "../../../mixins/apiMixin";

const BrandDeKonstrucktorSearching = {
    namespaced: true,
    state: {
        result: null,
        socialSearch: null,
        domainSearch: null,
        webSearch: null,
        europeTrademarkSearch: null,
        unitedkingdomTrademarkSearch: null,
        selectedKeyWord:null,
        HistoryDekonstrucktorSummaryPage:false,

        uksearchAvailable:null,
        europesearchAvailable:null,


        //search counts
        //------------------------------------------
        unitedkingdomTrademarkSearchCount: null,
        europeTrademarkSearchCount: null,
        domainSearchCount: null,
        domainfreeSearchCount: null,
        webSearchCount: null,
        socialSearchCount: null,

        //socialsearch icons
        twitterCount: false,
        facebookCount: false,
        linkedinCount: false,
        pininterestCount: false,
        instagramCount: false,
        youtubeCount: false,
        tiktokCount: false,
        redditCount: false,
        tumblrCount: false,
    },
    mutations: {
        settwitterCount:function(state, payload){
            state.twitterCount =payload;
        },
        setfacebookCount:function(state, payload){
            state.facebookCount =payload;
        },
        setlinkedinCount:function(state, payload){
            state.linkedinCount =payload;
        },
        setpininterestCount:function(state, payload){
            state.pininterestCount =payload;
        },
        setinstagramCount:function(state, payload){
            state.instagramCount =payload;
        },
        setyoutubeCount:function(state, payload){
            state.youtubeCount =payload;
        },
        settiktokCount:function(state, payload){
            state.tiktokCount =payload;
        },
        setredditCount:function(state, payload){
            state.redditCount =payload;
        },
        settumblrCount:function(state, payload){
            state.tumblrCount =payload;
        },

        setHistoryDekonstrucktorSummaryPage: function (state, payload) {
            state.HistoryDekonstrucktorSummaryPage = payload;

        },
        setResult: function (state, payload) {
            state.result = payload;

        },
        setsocialSearch: function (state, payload) {
            state.socialSearch = payload;

        },
        setdomainSearch: function (state, payload) {
            state.domainSearch = payload;

        },
        setwebSearch: function (state, payload) {
            state.webSearch = payload;

        },
        settrademarkSearch: function (state, payload) {
            state.europeTrademarkSearch = payload;

        },
        settrademark2Search: function (state, payload) {
            state.unitedkingdomTrademarkSearch = payload;

        }
    },
    actions: {
        getSearchCount:async function(state, payload){
            return await apiMixin.methods.getSearchCount(payload).then(
                response => {
                    if (!response) {
                        return false;
                    }
                    return response;
                });
        },
        updatePercentage:async function(state, payload){
            return apiMixin.methods.updatePercentage(payload).then(
                response => {
                    if (!response) {
                        return false;
                    }
                    return true;
                });
        },
        sendRequest: async function (state, payload) {
            return apiMixin.methods.dekonstruktSearch(payload).then(
                response => {
                    if (!response) {
                        return false;
                    }
                    return response;
                });
        },
        getResult: async function (state, payload) {

            return apiMixin.methods.dekonstruktResult(payload).then(
                response => {
                    if (!response) {
                        return false;
                    }
                    return response;
                });
        },

        socialSearchReady: async function (state, payload) {
            return apiMixin.methods.socialSearchReady(payload).then(
                response => {
                    if (!response) {
                        return false;
                    }
                    return response.data;
                });
        },
        domainSearchReady: async function (state, payload) {
            return apiMixin.methods.domainSearchReady(payload).then(
                response => {
                    if (!response) {
                        return false;
                    }
                    return response.data;
                });
        },
        webSearchReady: async function (state, payload) {
            return apiMixin.methods.webSearchReady(payload).then(
                response => {
                    if (!response) {
                        return false;
                    }
                    return response.data;
                });
        },
        uktrademarkSearchReady: async function (state, payload) {
            return apiMixin.methods.uktrademarkSearchReady(payload).then(
                response => {
                    if (!response) {
                        return false;
                    }
                    return response.data;
                });
        },
        europetrademarkSearchReady: async function (state, payload) {
            return apiMixin.methods.europetrademarkSearchReady(payload).then(
                response => {
                    if (!response) {
                        return false;
                    }
                    //console.log(response.data);
                    return response.data;
                });
        },
        userSelectedSearchCategory:async function (state, payload) {
            return apiMixin.methods.userSelectedSearchCategory(payload).then(
                response => {
                    if (!response) {
                        return false;
                    }

                    this.commit('BrandDeKonstrucktorMain/setdekonstrucktor_selected_types', response.data[0], {root: true})
                    return response.data[0];
                });
        },
    },
    getters: {
        getResult: function (state) {
            return state.result
        }
    }
}
export default BrandDeKonstrucktorSearching